var $f8c49dd804b75140$exports = {};
$f8c49dd804b75140$exports = {
    "breadcrumbs": `\u{5C0E}\u{89BD}\u{5217}`
};


export {$f8c49dd804b75140$exports as default};
//# sourceMappingURL=zh-TW.mjs.map
